import React from 'react';
import { ArrowRight, Heart } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="final-cta" className="w-full bg-gradient-to-b from-white to-lavender-light/20 py-24 px-6 md:px-8 text-center" style={{
    paddingTop: '50px',
    paddingBottom: '50px'
  }} data-id="element-34">
      <div className="max-w-2xl mx-auto" data-id="element-35">
        {/* Emotional opener */}
        <p className="text-base text-text-light mb-4 italic" data-id="element-36">
          Si estás leyendo esto con el bebé en brazos, a oscuras, con el celular
          en una mano…
        </p>

        <h2 className="text-3xl md:text-5xl font-bold text-text leading-tight mb-6" data-id="element-37">
          Esto es para ti. <br data-id="element-38" />
          <span className="text-lavender-dark" data-id="element-39">Justo ahora.</span>
        </h2>

        {/* Validation block */}
        <div className="bg-cream p-6 md:p-8 rounded-2xl border border-lavender/20 mb-10 text-left space-y-4" style={{
        paddingLeft: '15px',
        paddingRight: '15px'
      }} data-id="element-40">
          <p className="text-lg md:text-xl text-text leading-relaxed font-[400]" data-id="element-41">
            <span className="font-bold" data-id="element-42">No estás fallando.</span> Estás haciendo
            lo más difícil que has hecho en tu vida.
          </p>
          <p className="text-lg md:text-xl text-text leading-relaxed" data-id="element-43">
            Este guión no te va a convertir en una supermamá. Pero mañana,
            cuando abras los ojos sin saber qué hacer…{' '}
            <span className="font-bold" data-id="element-44">vas a tener una respuesta.</span>
          </p>
          <p className="text-lg md:text-xl text-text leading-relaxed" data-id="element-45">
            Y eso, cuando estás en modo zombie,
            <span className="font-bold" data-id="element-46"> lo cambia todo.</span>
          </p>
        </div>

        {/* The reframe — purchasing as self-care */}
        <div id="offer-price" className="mb-10 scroll-mt-10" data-id="element-47">
          <div className="inline-flex items-center gap-2 bg-lavender-light/50 px-4 py-1.5 rounded-full mb-4" data-id="element-48">
            <span className="text-xs text-lavender-dark uppercase tracking-wide font-[600]" data-id="element-49">
              🔥 Precio de lanzamiento
            </span>
            <span className="text-xs text-text-light font-[500]" data-id="element-50">
              • Por tiempo limitado
            </span>
          </div>

          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-51">
            <span className="text-2xl md:text-3xl line-through text-text-light/60" data-id="element-52">
              $19.89
            </span>
            <span className="text-4xl md:text-5xl font-bold text-lavender-dark" data-id="element-53">
              $6.36
            </span>
            <span className="text-sm text-text-light self-end mb-2" data-id="element-54">USD</span>
          </div>

          <p className="text-base md:text-lg text-text-light mb-3 italic" data-id="element-55">
            — Lo lancé a este precio para que ninguna mamá diga que no puede. —
          </p>

          <p className="text-xl md:text-2xl text-text mb-2 font-[200] font-['Tiro_Gurmukhi',_serif]" data-id="element-56">
            No es un gasto.
          </p>
          <p className="text-xl md:text-2xl font-serif text-lavender-dark font-bold" data-id="element-57">
            Es lo primero que haces por tí en semanas.
          </p>
        </div>

        {/* CTA button */}
        <a href="https://shop.magneticademente.com/cart/52272543695127:1" onClick={trackAddToCart} className="inline-flex items-center gap-3 bg-lavender-dark hover:bg-text text-white px-8 py-5 rounded-full md:text-xl font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 pt-[25px] pb-[25px] text-[25px] pl-[10px] pr-[10px]" data-id="element-58">
          Descargar Plan de Supervivencia → $6.36
        </a>

        {/* Closing emotional lines */}
        <div className="mt-8 space-y-3" data-id="element-59">
          <p className="md:text-xl text-text font-medium text-[22px]" data-id="element-60">
            Mañana no empieza en cero. <br data-id="element-61" />
            Mañana empiezas con un plan.
          </p>
          <div className="flex items-center justify-center gap-2 text-text-light mt-4" data-id="element-62">
            <Heart className="w-4 h-4 text-rose-DEFAULT" data-id="element-63" />
            <p className="text-sm italic" data-id="element-64">
              De una mamá que también estuvo ahí, para ti.
            </p>
          </div>
          <p className="text-text-light italic mt-2 text-[14px]" data-id="element-65">
            — Magnética deMente © 2026
          </p>
        </div>
      </div>
    </section>;
}